/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PatientSearch from './PatientSearch/index'
import PatientTrigger from './PatientTrigger/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContent from 'DesignSystem/Popover/PopoverContent/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaIconArrowForward from 'DesignSystem/Svgs/TysiaIconArrowForward/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Patient/Content"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaIconArrowForward
  viewPath={`${viewPath}/TysiaIconArrowForward`}
 height={10}
 width={10}
 fill={dtColorsNeutral400}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<PatientTrigger
{...childProps}
  viewPath={`${viewPath}/PatientTrigger`}
/>
)}
</PopoverTrigger>
<PopoverContent
{...childProps}
  viewPath={`${viewPath}/PopoverContent`}
>
{childProps => (
<PatientSearch
{...childProps}
  viewPath={`${viewPath}/PatientSearch`}
/>
)}
</PopoverContent>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}